import React from 'react';

import { useNavigate } from 'react-router';

import { useAuthCredentials } from '@hrlogics/react-auth';

import { appRoutes } from '@clearverify/constants';

import { PasswordRequestType, useCheckPasswordRequestExistQuery } from 'src/api';
import { FullscreenLoader } from 'src/components/common';
import { ModalId } from 'src/constants/modals';
import { useNotification } from 'src/hooks/app';
import { useModal } from 'src/hooks/shared';
import { useUserPasswordChangeRequestIdParamId } from 'src/hooks/user';
import { UserChangePasswordModal } from 'src/modals/userPasswordChangeRequest';

export const ChangePasswordPage: React.FC = () => {
  const { spawnNotification } = useNotification();

  const { openModal } = useModal();

  const { isAuthorized } = useAuthCredentials();

  const userPasswordChangeRequestId = useUserPasswordChangeRequestIdParamId();

  const navigate = useNavigate();

  React.useEffect(() => {
    if (!isAuthorized) {
      navigate(appRoutes.auth.index);
    }
  });

  const { data, loading } = useCheckPasswordRequestExistQuery({
    variables: {
      requestId: String(userPasswordChangeRequestId),
      requestType: PasswordRequestType.Change,
    },
    skip: !userPasswordChangeRequestId,
  });

  React.useEffect(() => {
    if (loading) {
      return;
    }

    if (data?.checkPasswordRequestExist.success) {
      openModal(ModalId.UserChangePasswordModal);
    }

    if (!data?.checkPasswordRequestExist.success) {
      navigate(appRoutes.auth.index);
      spawnNotification('Change Password Request not exist or expired', 'error');
    }
  }, [data?.checkPasswordRequestExist.success, loading, navigate, openModal, spawnNotification]);

  if (loading) {
    return <FullscreenLoader />;
  }

  return <UserChangePasswordModal />;
};
